import {PageHeader} from '../layout/PageHeader'

const StandingOrdersWrapper = () => {
  return (
    <>
      <PageHeader
        eyebrow='Торговля'
        title='Постоянные заявки'
        description='Автоматические заявки с контролем цены, объёма и защитными ограничениями.'
      />
      <standing-orders-page />
    </>
  )
}

export {StandingOrdersWrapper}
